<div class="dialog-header" i18n>
    <div class="row space-between">
        <h2>{{ data.headerText }}</h2>

        <rr-icon name="close" class="pointer" (click)="close()"></rr-icon>
    </div>
</div>

<div class="dialog-content" i18n>
    <p>{{ data.dialogText}}</p>
</div>

<div class="dialog-actions w100" i18n>
    @if (data.cancelText) {
    <rr-btn type="Link" size="Medium" (btnclick)="close()">
        {{ data.cancelText }}
    </rr-btn>
    }

    <rr-btn type="Primary" size="Medium" (btnclick)="confirm()">
        {{ data.submitText }}
    </rr-btn>
</div>

